
import { RegionIdEnum } from '@search/filter-enums/enums/Region';

export const checkRegionIsPromoSamolet = (region: number) => {
    return (
        region === RegionIdEnum.MSK ||
        region === RegionIdEnum.MSK_AND_MSK_OBL ||
        region === RegionIdEnum.MSK_OBL
    );
};
